import axios from 'axios'
// 创建axios实例
const api = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API || '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    console.log('发送请求:', config.method?.toUpperCase(), config.url)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    console.log('请求成功:', response.status)
    return response.data
  },
  error => {
    console.error('请求失败:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export default api

async function getActivityDetail(activityId) {
  try {
    const result = await api.get(`/api/activities/general/crm/front/config?activity_id=${activityId}`)
    return result
  } catch (error) {
    console.error('获取活动详情失败:', error)
    throw error
  }
}

export async function setActivityConfig(to) {
  return new Promise(async (resolve, reject) => {
    if (!to.meta?.id) {
      resolve()
      return
    }

    try {
      const activityConfig = await getActivityDetail(to.meta?.id)
      const { activity_code, activity_id, assets, json, texts, components, end_timestamp, start_timestamp } =
        activityConfig?.data || {}
      to.meta.assets = assets || []
      to.meta.assetsMap = assets?.reduce((acc, item) => {
        acc[item.key] = item
        return acc
      }, {})
      to.meta.json = json || {}
      to.meta.texts = texts || {}
      to.meta.activity_code = activity_code
      to.meta.activity_id = activity_id
      to.meta.components = components || {}
      to.meta.endTime = end_timestamp || 0
      to.meta.startTime = start_timestamp || 0

      console.log('to.meta', to.meta)
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}
